/* global connect React Component AppWrapper */

export class Dashboard extends Component {
  constructor(props) {
    super(props);
    props.initialconstruct.bind(this)("Dashboard");
    this.fields = [
      {
        name:"old_password",
        label:"Old Password",
        type:"password",
        required:true
      },
      {
        name:"new_password",
        label:"New Password",
        type:"password",
        required:true
      }
    ]
  }

  componentDidMount() {
    if(!this.props.store.user.is_password_updated) {
      document.querySelector("#passwordresettrigger").click()
    }
    //is_password_updated
  }

  restPassword(e,data,form,close) {
    this.api.execApi('putPassword',data).then(async (response)=>{
      success("Password Changed successfully");
      close.click();
    }).catch((err)=>{
      failure("Password Changed un-successfully. try again later");
      close.click();
    });
  }

  render() {
    /* eslint-disable-next-line react/jsx-no-undef */
    return (
      <AppWrapper customTitle="Welcome Admin!" title="Dashboard" back="">
        <div className="row">
          <div className="col-md-6 col-sm-6 col-lg-6 col-xl-3">
            <div className="card dash-widget">
              <div className="card-body">
                <span className="dash-widget-icon">
                  <i className="fa fa-user" />
                </span>
                <div className="dash-widget-info">
                  <h3>234</h3>
                  <span>Total Emplyees</span>
                </div>
              </div>
            </div>
          </div>
          <div className="col-md-6 col-sm-6 col-lg-6 col-xl-3">
            <div className="card dash-widget">
              <div className="card-body">
                <span className="dash-widget-icon">
                  <i className="fa fa-user" />
                </span>
                <div className="dash-widget-info">
                  <h3>234</h3>
                  <span>Active Emplyees</span>
                </div>
              </div>
            </div>
          </div>
          <div className="col-md-6 col-sm-6 col-lg-6 col-xl-3">
            <div className="card dash-widget">
              <div className="card-body">
                <span className="dash-widget-icon">
                  <i className="fa fa-diamond" />
                </span>
                <div className="dash-widget-info">
                  <h3>234</h3>
                  <span>Today’s Present</span>
                </div>
              </div>
            </div>
          </div>
          <div className="col-md-6 col-sm-6 col-lg-6 col-xl-3">
            <div className="card dash-widget">
              <div className="card-body">
                <span className="dash-widget-icon">
                  <i className="fa fa-user" />
                </span>
                <div className="dash-widget-info">
                  <h3>234</h3>
                  <span>Today’s Absent</span>
                </div>
              </div>
            </div>
          </div>
          <div className="col-md-6 col-sm-6 col-lg-6 col-xl-3">
            <div className="card dash-widget">
              <div className="card-body">
                <span className="dash-widget-icon">
                  <i className="fa fa-user" />
                </span>
                <div className="dash-widget-info">
                  <h3>234</h3>
                  <span>On Leave</span>
                </div>
              </div>
            </div>
          </div>
          <div className="col-md-6 col-sm-6 col-lg-6 col-xl-3">
            <div className="card dash-widget">
              <div className="card-body">
                <span className="dash-widget-icon">
                  <i className="fa fa-user" />
                </span>
                <div className="dash-widget-info">
                  <h3>234</h3>
                  <span>Leave Approvals</span>
                </div>
              </div>
            </div>
          </div>
          <div className="col-md-6 col-sm-6 col-lg-6 col-xl-3">
            <div className="card dash-widget">
              <div className="card-body">
                <span className="dash-widget-icon">
                  <i className="fa fa-user" />
                </span>
                <div className="dash-widget-info">
                  <h3>234</h3>
                  <span>Exception Approvals</span>
                </div>
              </div>
            </div>
          </div>
          <div className="col-md-6 col-sm-6 col-lg-6 col-xl-3">
            <div className="card dash-widget">
              <div className="card-body">
                <span className="dash-widget-icon">
                  <i className="fa fa-user" />
                </span>
                <div className="dash-widget-info">
                  <h3>234</h3>
                  <span>Payslip Request</span>
                </div>
              </div>
            </div>
          </div>
        </div>
        <a id="passwordresettrigger" href="#" className="btn add-btn hidden" data-bs-toggle="modal" data-bs-target="#passwordreset">
        </a>
        <AppModalForm
          id="passwordreset"
          title="Update Password"
          closable={false}
          fields={this.fields}
          onSubmit={(...arg) => this.restPassword(...arg)}
          submitText="Submit">
        </AppModalForm>
      </AppWrapper>
    )
  }
}

export default connect(Dashboard);